import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import cn from 'classnames';

import styles from './styles.styl';
import { TimeShow } from '../../../common/TimeShow';
import { COMPLAINT_TYPE } from '../../../../constants';

const translationsByType = {
  [COMPLAINT_TYPE.COMMUNITY]: 'reports.community.type',
  [COMPLAINT_TYPE.COMMENT]: 'reports.comment.type',
  [COMPLAINT_TYPE.POST]: 'reports.post.type',
};

const translationsByStatus = {
  unresolved: 'community.reports.unresolved',
  resolved: 'community.reports.resolved',
};

export const ReportInfoImpl = ({
  formatMessage,
  createdAt,
  status,
  type,
  reason,
  column,
  showDangerTitle,
  showTimerTitle,
}) => {
  return (
    <div styleName={cn('root', { 'root--column': column })}>
      <div styleName="item">
        <If condition={showTimerTitle}>
          <p>{formatMessage({ id: 'reports.time' })}:</p>
        </If>
        <TimeShow timestamp={createdAt} />
      </div>
      <div styleName="item">
        <p>{formatMessage({ id: 'reports.status' })}:</p>
        <span styleName="item-text">
          {formatMessage({ id: translationsByStatus[status] })}
        </span>
      </div>
      <div styleName="item">
        <p>{formatMessage({ id: 'reports.type' })}:</p>
        <span styleName="item-text">
          to the {formatMessage({ id: translationsByType[type] })}
        </span>
      </div>
      <div styleName="item">
        <p>{formatMessage({ id: 'reports.reason' })}:</p>
        <span
          styleName={cn('item-text', { 'item-text--danger': showDangerTitle })}
        >
          {reason.name}
        </span>
      </div>
    </div>
  );
};

export const ReportInfo = compose(CSSModules(styles, { allowMultiple: true }))(
  ReportInfoImpl,
);

const propTypes = {
  formatMessage: PropTypes.func.isRequired,
  createdAt: PropTypes.string,
  status: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  reason: PropTypes.object.isRequired,
  column: PropTypes.bool,
  showDangerTitle: PropTypes.bool,
  showTimerTitle: PropTypes.bool,
};

ReportInfoImpl.defaultProps = {
  column: false,
  createdAt: '',
  showDangerTitle: false,
  showTimerTitle: false,
};

ReportInfoImpl.propTypes = propTypes;
ReportInfo.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/Communities/Reports/ReportInfoRow/index.jsx